export const isLocalDevelopment = () => process.env.NODE_ENV === "development";
